var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"p-4 rounded-sm bg-blue-400 text-white",domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":function($event){_vm.label = 'Működik'}}})}
var staticRenderFns = []

export { render, staticRenderFns }